import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGoogle, faYoutube, faMedium, faXTwitter, faReddit, faAmazon, } from "@fortawesome/free-brands-svg-icons";
import { faMap } from "@fortawesome/free-regular-svg-icons";
import { faN } from "@fortawesome/free-solid-svg-icons";
const GOOGLE_SEARCH = "!g";
const YOUTUBE_SEARCH = "!yt";
const NETFLIX_SEARCH = "!nf";
const MEDIUM_SEARCH = "!md";
const MEDIUM_UNLIMITED_SEARCH = "!mdul";
const GOOGLE_MAP_SEARCH = "!maps";
const TWITTER_SEARCH = "!tw";
const REDDIT_SEARCH = "!r";
const AMAZON_SEARCH = "!a";
export const SEARCH_BANGS = [
    GOOGLE_SEARCH,
    YOUTUBE_SEARCH,
    NETFLIX_SEARCH,
    MEDIUM_SEARCH,
    GOOGLE_MAP_SEARCH,
    TWITTER_SEARCH,
    REDDIT_SEARCH,
    AMAZON_SEARCH,
];
export const BANG_SEARCH_QUERY_MAP = {
    [GOOGLE_SEARCH]: "https://www.google.com/search?q=",
    [YOUTUBE_SEARCH]: "https://www.youtube.com/results?search_query=",
    [NETFLIX_SEARCH]: "https://www.netflix.com/search?q=",
    [MEDIUM_SEARCH]: "https://medium.com/search?q=",
    [MEDIUM_UNLIMITED_SEARCH]: "https://archive.is/4tu6u/again?url=",
    [GOOGLE_MAP_SEARCH]: "https://www.google.com/maps/search/",
    [TWITTER_SEARCH]: "https://twitter.com/search?q=",
    [REDDIT_SEARCH]: "https://www.reddit.com/search/?q=",
    [AMAZON_SEARCH]: "https://www.amazon.com/s?k=",
};
export const DEFAULT_SEARCH_QUERY = "https://www.ecosia.org/search?q=";
const ICON_PROPS = "h-5 w-5";
export const SEARCH_BANG_OPTIONS = [
    {
        bang: GOOGLE_SEARCH,
        label: "Google Search",
        icon: _jsx(FontAwesomeIcon, { icon: faGoogle, className: `${ICON_PROPS} text-[#4285F4]` }), // Google Blue
    },
    {
        bang: YOUTUBE_SEARCH,
        label: "Youtube Search",
        icon: _jsx(FontAwesomeIcon, { icon: faYoutube, className: `${ICON_PROPS} text-[#FF0000]` }), // YouTube Red
    },
    {
        bang: NETFLIX_SEARCH,
        label: "Netflix Search",
        icon: _jsx(FontAwesomeIcon, { icon: faN, className: `${ICON_PROPS} text-[#E50914]` }), // Netflix Red
    },
    {
        bang: MEDIUM_SEARCH,
        label: "Medium Search",
        icon: _jsx(FontAwesomeIcon, { icon: faMedium, className: `${ICON_PROPS} text-[#00AB6C]` }), // Medium Green
    },
    {
        bang: MEDIUM_UNLIMITED_SEARCH,
        label: "Medium Unlimited",
        icon: _jsx(FontAwesomeIcon, { icon: faMedium, className: `${ICON_PROPS} text-[#00AB6C]` }), // Same Medium Green
    },
    {
        bang: GOOGLE_MAP_SEARCH,
        label: "Google Maps Search",
        icon: _jsx(FontAwesomeIcon, { icon: faMap, className: `${ICON_PROPS} text-[#34A853]` }), // Maps Green
    },
    {
        bang: TWITTER_SEARCH,
        label: "Twitter Search",
        icon: _jsx(FontAwesomeIcon, { icon: faXTwitter, className: `${ICON_PROPS} text-black` }), // X / Twitter Black
    },
    {
        bang: REDDIT_SEARCH,
        label: "Reddit Search ",
        icon: _jsx(FontAwesomeIcon, { icon: faReddit, className: `${ICON_PROPS} text-[#FF4500]` }), // Reddit Orange
    },
    {
        bang: AMAZON_SEARCH,
        label: "Amazon",
        icon: _jsx(FontAwesomeIcon, { icon: faAmazon, className: `${ICON_PROPS} text-[#FF9900]` }), // Amazon Orange
    },
];
